/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiPageStatusFromJSON, ApiPageStatusToJSON, } from './ApiPageStatus';
export function ApiPageSimplifiedFromJSON(json) {
    return ApiPageSimplifiedFromJSONTyped(json, false);
}
export function ApiPageSimplifiedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'analyticsSynced': !exists(json, 'analyticsSynced') ? undefined : json['analyticsSynced'],
        'crawledAt': !exists(json, 'crawledAt') ? undefined : (new Date(json['crawledAt'])),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'displayPage': !exists(json, 'displayPage') ? undefined : json['displayPage'],
        'domainId': !exists(json, 'domainId') ? undefined : json['domainId'],
        'errorCounter': !exists(json, 'errorCounter') ? undefined : json['errorCounter'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lastActivityAt': !exists(json, 'lastActivityAt') ? undefined : (new Date(json['lastActivityAt'])),
        'locatedAt': !exists(json, 'locatedAt') ? undefined : (new Date(json['locatedAt'])),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'status': !exists(json, 'status') ? undefined : ApiPageStatusFromJSON(json['status']),
        'statusCode': !exists(json, 'statusCode') ? undefined : json['statusCode'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiPageSimplifiedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'analyticsSynced': value.analyticsSynced,
        'crawledAt': value.crawledAt === undefined ? undefined : (value.crawledAt.toISOString()),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'displayPage': value.displayPage,
        'domainId': value.domainId,
        'errorCounter': value.errorCounter,
        'id': value.id,
        'lastActivityAt': value.lastActivityAt === undefined ? undefined : (value.lastActivityAt.toISOString()),
        'locatedAt': value.locatedAt === undefined ? undefined : (value.locatedAt.toISOString()),
        'page': value.page,
        'projectId': value.projectId,
        'status': ApiPageStatusToJSON(value.status),
        'statusCode': value.statusCode,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
